module.exports = __webpack_public_path__ + "img/discount-ash.8cd0c3f0.png";